module.exports = __webpack_public_path__ + "distribution/img/heder_cont.bf3caec0.png";